import { FuelButton, FuelCheckbox, FuelGridContainer, FuelRadio } from '@frete.com/fuel-react'
import styled from 'styled-components'

export const GridContainer = styled(FuelGridContainer)`
  margin: 0 !important;
`

export const FilterButtons = styled.div`
  margin-top: ${({ theme }) => theme.spacing.km6};
  display: flex;
  justify-content: flex-end;
`

export const Radio = styled(FuelRadio)`
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`

export const Checkbox = styled(FuelCheckbox)`
  margin: 0 ${({ theme }) => theme.spacing.km10} ${({ theme }) => theme.spacing.km3} 0;
`

export const CleanButton = styled(FuelButton)`
  margin-right: ${({ theme }) => theme.spacing.km6};
`
